// This file was written with AI assistance.
const activeRecordScopeRegistrations = {}
const SCOPE_NAME_PATTERN = /^use[A-Z0-9]/

export const registerActiveRecordScopes = (Model, scopes) => {
	const modelKey = Model?.tableName
	const modelLabel = modelKey || Model?.name

	if (!modelKey) {
		throw new Error(`Cannot register ActiveRecord scopes without a model tableName (received ${modelLabel}).`)
	}

	if (!scopes || typeof scopes !== 'object' || Array.isArray(scopes)) {
		throw new Error(`Cannot register ActiveRecord scopes for ${modelKey} without a scope groups object.`)
	}

	for (const scopeGroupName in scopes) {
		const scopeGroup = scopes[scopeGroupName]

		if (!(scopeGroupName in Model)) {
			throw new Error(
				`Cannot register ActiveRecord scope group ${scopeGroupName} for ${modelKey}; ${modelLabel}.${scopeGroupName} is not defined.`,
			)
		}

		if (!scopeGroup || typeof scopeGroup !== 'object' || Array.isArray(scopeGroup)) {
			throw new Error(`Cannot register ActiveRecord scope group ${scopeGroupName} for ${modelKey} without a scopes object.`)
		}

		for (const scopeName in scopeGroup) {
			const scopePath = `${scopeGroupName}.${scopeName}`
			const useScope = scopeGroup[scopeName]

			if (!SCOPE_NAME_PATTERN.test(scopeName)) {
				throw new Error(`Cannot register ActiveRecord scope ${scopePath} for ${modelKey}; scope names must start with "use".`)
			}

			if (typeof useScope !== 'function') {
				throw new Error(`Cannot register ActiveRecord scope ${scopePath} for ${modelKey} without a hook function.`)
			}
		}
	}

	activeRecordScopeRegistrations[modelKey] = scopes
}

export const getActiveRecordScopeGroup = (Model, scopeGroupName) => {
	const modelKey = Model?.tableName
	const modelLabel = modelKey || Model?.name
	const scopes = activeRecordScopeRegistrations[modelKey]

	if (!scopes) throw new Error(`No ActiveRecord scopes registered for ${modelLabel}.`)

	const scopeGroup = scopes[scopeGroupName]

	if (!scopeGroup) throw new Error(`No ActiveRecord scope group ${scopeGroupName} registered for ${modelLabel}.`)

	return scopeGroup
}
